import { connect } from "../../utils/reduxUtils"
import Component from "./SingleApplication"
import { Actions } from "../../pages/actions"
import * as ApplicationsSelectors from '../../modules/applications/selectors'
import * as MessagesSelectors from '../../modules/messages/selectors'

const mapDispatchToProps = {
    onSubmitCreate: Actions.APPLICATION_FORM_REPLICATE,
    onSubmitUpdate: Actions.EDIT_APPLICATION_FORM_SUBMITTED,
    onMount: Actions.SINGLE_APPLICATION_PAGE_MOUNTED,
    changeTab: Actions.ACTIVE_TAB_CHANGED,
    onMessagesMount: Actions.MESSAGES_PAGE_MOUNTED,
    onSendMessage: Actions.SEND_MESSAGE_SUBMITTED,
    onMarkMessageRead: Actions.MARK_MESSAGE_READ,

};

const mapStateToProps = state => {
    return {
        application: ApplicationsSelectors.application(state),
        loading: ApplicationsSelectors.isLoading(state),
        error: ApplicationsSelectors.error(state),
        submitSuccess: ApplicationsSelectors.submitSuccess(state),
        isSubmitting: ApplicationsSelectors.isSubmitting(state),
        messages: MessagesSelectors.messages(state),
        messagesLoading: MessagesSelectors.isLoading(state),
        messageSending: MessagesSelectors.isSending(state),
        messageSendSuccess: MessagesSelectors.sendSuccess(state),
    };
}

export default connect(mapStateToProps, mapDispatchToProps,null,{forwardRef:true})(Component);